<template>
	<div class="index-wrap">
		<loader></loader>
		<page-head></page-head>

		<!-- Start Banner -->
		<section class="banner-section">
			<div class="banner-carousel owl-carousel">
				<div class="slide-item one" v-for="(item,index) in bannerList" :key="index">
					<div class="image-layer" :style="{'background-image': 'url(' + item.imageUrl + ')'}"></div>
					<div class="container">
						<div class="slider-content">
							<div class="slider-sub-title">
								<h4>{{ item.subTitle }}</h4>
								<h1>{{item.name}}</h1>
							</div>
							<div class="slider-main-title">
								<h4 v-for="(m,i) in item.mainTitle" :key="i">{{m}}</h4>
							</div>
							<div class="it-expart-btn slider">
								<a @click="constactClick" class="header-button" href="javascript:;">联系我们<span></span></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- End Banner -->

		<!-- Start 关于泽火 -->
		<div class="about-area">
			<div class="container">
				<div class="row">
					<div class="col-lg-6 col-md-12">
						<div class="about-thumb">
							<img src="@/assets/image/about/about-thumb3.jpg" alt="">
							<!-- <div class="about-shape bounce-animate ">
								<img src="static/picture/shape3.png" alt="">
							</div> -->
						</div>
					</div>
					<div class="col-lg-6 col-md-12">
						<div class="section-title">
							<div class="section-sub-title about3">
								<h4>让科技便捷生活<!-- 技术创新为安全赋能 --></h4>
							</div>
							<div class="section-main-title about3">
								<h2>综合管理服务</h2>
								<h2>解决方案及大数据服务</h2>
							</div>
						</div>
						<div class="about-content">
							<div class="about-discribtion">
								<p>
									泽火时代科技（厦门）有限公司，一家坐落于美丽的海滨城市厦门的科技型创新技术企业，专注于物联网技术的前沿探索与实践应用。公司秉承“让科技便捷生活”的愿景，致力于通过智能化解决方案提升人们的生活质量和工作效率。泽火时代科技的业务版图涵盖智慧消防、安全用电、结构安全和水利灌区四大核心领域，旨在通过科技创新，为现代城市的安全与便捷注入新动力。
								</p>
							</div>
							<div class="process-ber-plugin">
								<span class="process-bar">技术人员占比</span>
								<div id="bar1" class="barfiller">
									<div class="tipWrap" style="display: inline;">
										<span class="tip"
											style="left: 334.106px; transition: left 7s ease-in-out 0s;">83%</span>
									</div>
									<span class="fill" data-percentage="83"
										style="background: rgb(22, 181, 151); width: 83%; transition: width 7s ease-in-out 0s;"></span>
								</div>
								<span class="process-bar">客户满意度</span>
								<div id="bar2" class="barfiller">
									<div class="tipWrap" style="display: inline;">
										<span class="tip"
											style="left: 225.586px; transition: left 7s ease-in-out 0s;">100%</span>
									</div>
									<span class="fill my-class" data-percentage="100"
										style="background: rgb(22, 181, 151); width: 100%; transition: width 7s ease-in-out 0s;"></span>
								</div>
							</div>
							<!-- <div class="about-bottom" style="display: none;">
								<div class="about-bottom-thumb">
									<img src="static/picture/about-bottom.png" alt="">
								</div>
								<div class="about-bottom-title">
									<h4>Max Benjamin</h4>
									<span>Director</span>
								</div>
								<div class="about-signiture">
									<img src="static/picture/signiture.png" alt="">
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- End 关于泽火 -->

		<!-- Start 泽火服务 -->
		<div class="contact-us-area">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-6 col-md-12">
						<div class="contact-us-items">
							<div class="contact-us-content style-three">
								<h4>Core business</h4>
								<h2>核心业务</h2>
							</div>
							<div class="contact-us-list">
								<span><i class="bi bi-check"></i>智慧消防</span>
								<span><i class="bi bi-check"></i>安全用电</span>
								<span><i class="bi bi-check"></i>结构安全</span>
								<span><i class="bi bi-check"></i>水利灌区</span>
							</div>
						</div>
					</div>
					<div class="col-lg-6 col-md-12">
						<div class="contact-us-items-box">
							<div class="contact-icon-thumb">
								<img src="@/assets/image/contact/contact-icon.png" alt="">
							</div>
							<div class="contact-items-content">
								<h6>联系我们</h6>
								<h4><a href="javascript:;">+0592-6217119</a></h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- End 泽火服务 -->

		<!-- Start 解决方案 -->
		<div class="service-area">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="section-title text-center">
							<div class="section-sub-title">
								<h4>SOLUTION</h4>
							</div>
							<div class="section-main-title">
								<h2>解决方案</h2>
								<!-- <h2>Your Business Growth</h2> -->
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-3 col-md-6" v-for="(item,index) in solutionList" :key="index">
						<div class="service-single-box">
							<div class="service-conten">
								<div class="service-title">
									<h4><a href="javascript:;">{{ item.name }}</a></h4>
								</div>
								<div class="underline">
									<div class="br-line"></div>
								</div>
								<div class="serivice-discription">
									<p>{{ item.intro}}</p>
								</div>
							</div>
							<div class="service-bottom">
								<div class="service-icon">
									<img :src="item.icon" alt="">
								</div>
								<div class="it-expart-btn service">
									<a class="header-button" @click="goSolution(item)" href="javascript:;">详情 <span></span></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- End 解决方案 -->

		<!-- Start 泽火优势 -->
		<div class="sucsess-area">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="section-title text-center">
							<div class="section-sub-title">
								<h4>Ze Huo Superiority</h4>
							</div>
							<div class="section-main-title">
								<h2>泽火优势</h2>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-4 col-md-6">
						<div class="sucsees-item-box dz">
							<div class="sucsess-item-two">
								<h4>定制化</h4>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6">
						<div class="sucsees-item-box jx">
							<div class="sucsess-item-two">
								<h4>精细化</h4>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6">
						<div class="sucsees-item-box zy">
							<div class="sucsess-item-two">
								<h4>专业化</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- End 泽火优势 -->
		
		<!-- 手机端菜单栏  -->
		<side-bar></side-bar>

		<page-footer></page-footer>

		<!-- Start 回到顶部 -->
		<div class="scroll-area">
			<div class="top-wrap">
				<div class="go-top-btn-wraper">
					<div class="go-top go-top-button">
						<i class="fas fa-arrow-up"></i>
						<i class="fas fa-arrow-up"></i>
					</div>
				</div>
			</div>
		</div>
		<!-- End 回到顶部 -->
	</div>
</template>

<script>
	import loader from "@/components/loader.vue"
	import pageHead from "@/components/pageHead.vue"
	import pageFooter from "@/components/pageFooter.vue"
	import sideBar from "@/components/sideBar.vue"
	export default {
		components: {
			loader,
			pageHead,
			pageFooter,
			sideBar
		},
		data() {
			return {
				bannerList: [{
						name: '智慧消防',
						subTitle: 'Smart FireProtection',
						imageUrl: require('@/assets/image/banner/slider5.png'),
						mainTitle: ['SaaS化服务', '满足消防安全标准化管理需求']
					},
					{
						name: '安全用电',
						subTitle: 'Safe Electricity Usage',
						imageUrl: require('@/assets/image/banner/slider6.png'),
						mainTitle: ['插座进水不漏电，线路老化不起火']
					},
					{
						name: '水利灌区',
						subTitle: 'Water conservancy irrigation area',
						imageUrl: require('@/assets/image/banner/slider7.jpg'),
						mainTitle: ['提供一站式解决方案','水库、大坝、灌区等多场景适用']
					},
					{
						name: '结构安全',
						subTitle: 'structural safety',
						imageUrl: require('@/assets/image/banner/slider8.jpg'),
						mainTitle: ['结构安全态势感知','建筑、桥梁、边坡、综合管廊等多场景适用']
					},
				],
				solutionList: [{
						id: 1,
						hash: '#fire',
						router: '/solution',
						name: '智慧消防',
						intro: '为政、企单位以及维保机构搭建“1+N”的防火技术服务和监督执法的智能化消防安全防控体系，提供全链条一站式消防SaaS化服务，全面提升政府消防监管工作信息化水平。',
						icon: require('@/assets/image/solution/service-icon1.png')
					},
					{
						id: 2,
						hash: '#electrical',
						router: '/solution',
						name: '安全用电',
						intro: '为各大用电场所提供完善可靠远程集中可测可控可监可视的智能化手段，实现对前端各类用电设备的远程集中精细化管理，进一步提升了远程监控中心的风险预警能力和管理效率。',
						icon: require('@/assets/image/solution/service-icon2.png')
					},
					{
						id: 3,
						hash: '#structure',
						router: '/solution',
						name: '结构安全',
						intro: '结构安全监测预警系统主要围绕城市生命线开展的安全监测，结合城市排水、供水、燃气、房屋、桥梁、隧道、综合管廊等城市基础设施，以及边坡，地质灾害等应用场景，采用物联网手段，建立综合风险研判，事故预测分析，事故风险预案，警情分级响应，协同应急指挥，报警处置跟踪等综合应用机制。',
						icon: require('@/assets/image/solution/service-icon3.png')
					},
					{
						id: 3,
						hash: '#water',
						router: '/solution',
						name: '水利灌区',
						intro: '以“管理系统”为基础，构建孪生综合解决方案，以实际业务需求为导向，利用孪生仿真能力结合物联网技术，融合现有数据资源和水利专业模型，全面实现水库，灌区、流域“四全”、“四制（治）”、“四预”、“四管”的管理矩阵功能。',
						icon: require('@/assets/image/solution/service-icon4.png')
					},
				]
			}
		},
		created() {
			$("html, body").animate({
				scrollTop: "0"
			}, 500);
		},
		mounted() {
			// 回到顶部
			$('.go-top').on('click', function() {
				$("html, body").animate({
					scrollTop: "0"
				}, 1200);
			});
			// Preloader
			$(document).ready(function() {
				setTimeout(function() {
					$('.loader_bg').fadeToggle();
				}, 1000);
			});

			// 菜单悬浮
			var wind = $(window);
			var sticky = $('#sticky-header');
			wind.on('scroll', function() {
				var scroll = wind.scrollTop();
				if (scroll < 100) {
					sticky.removeClass('sticky-nav');
				} else {
					sticky.addClass('sticky-nav');
				}
			});
			// Slider
			$('.banner-carousel').owlCarousel({
				items: 1,
				autoplay: true,
				autoplayTimeout: 5000,
				loop: true,
				animateOut: 'fadeOut',
				dots: false,
				nav: false,
				navText: ["01", "02", "03"],
			});

			// Slider
			$('.banner-carousel').owlCarousel({
				items: 1,
				autoplay: true,
				autoplayTimeout: 5000,
				loop: true,
				animateOut: 'fadeOut',
				dots: false,
				nav: true,
				navText: ["<i class='bi bi-arrow-right''></i>", "<i class='bi bi-arrow-left''></i>"],
			});
			
			$(document).ready(function (o) {
			    0 < o(".offset-side-bar").length &&
			        o(".offset-side-bar").on("click", function (e) {
			            e.preventDefault(), e.stopPropagation(), o(".cart-group").addClass("isActive");
			        }),
			        0 < o(".close-side-widget").length &&
			        o(".close-side-widget").on("click", function (e) {
			            e.preventDefault(), o(".cart-group").removeClass("isActive");
			        }),
			        0 < o(".navSidebar-button").length &&
			        o(".navSidebar-button").on("click", function (e) {
			            e.preventDefault(), e.stopPropagation(), o(".info-group").addClass("isActive");
			        }),
			        0 < o(".close-side-widget").length &&
			        o(".close-side-widget").on("click", function (e) {
			            e.preventDefault(), o(".info-group").removeClass("isActive");
			        }),
			        o("body").on("click", function (e) {
			            o(".info-group").removeClass("isActive"), o(".cart-group").removeClass("isActive");
			        }),
			        o(".sidebar-widget").on("click", function (e) {
			            e.stopPropagation();
			        }),
			        0 < o(".xs-modal-popup").length &&
			        o(".xs-modal-popup").magnificPopup({
			            type: "inline",
			            fixedContentPos: !2,
			            fixedBgPos: !0,
			            overflowY: "auto",
			            closeBtnInside: !2,
			            callbacks: {
			                beforeOpen: function () {
			                    this.st.mainClass = "my-mfp-slide-bottom xs-promo-popup";
			                },
			            },
			        });
			});
		},
		methods: {
			constactClick() {
				if ('/contactUs' == this.$route.path) return
				this.$router.push('/contactUs')
			},
			goSolution(item) {
				this.$router.push({path: item.router, hash: item.hash})
			}
		}
	}
</script>

<style lang="scss" scoped>
</style>